export default {
      id: "microphone-not-available-usage",
      viewBox: "0 0 420 420",
      url: __webpack_public_path__ + "img/icons.svg#microphone-not-available",
      toString: function () {
        return this.url;
      }
    }